module.exports = __webpack_public_path__ + "img/508.82e3a168.png";